var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.812 13.7233C14.812 14.7609 14.022 15.6006 12.7865 15.6006C11.5991 15.6006 10.8091 14.7609 10.8336 13.7233C10.8091 12.6353 11.5991 11.8201 12.8102 11.8201C14.0219 11.8201 14.7883 12.6353 14.812 13.7233ZM10.9329 29.1694V17.0836H14.689V29.1686H10.9329V29.1694Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6997 20.9406C17.6997 19.4331 17.65 18.148 17.6003 17.0852H20.8628L21.0363 18.7409H21.1104C21.6047 17.9746 22.8402 16.814 24.8421 16.814C27.313 16.814 29.1666 18.4452 29.1666 22.0026V29.171H25.4105V22.4733C25.4105 20.9154 24.8673 19.8534 23.508 19.8534C22.4697 19.8534 21.8523 20.57 21.6055 21.2615C21.5062 21.5091 21.4573 21.8544 21.4573 22.2013V29.171H17.7012V20.9406H17.6997Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.2443640e.svg";
export { ForwardRef as ReactComponent };